<template>
    <span class="inline-flex items-center space-x-1" :class="{ 'text-red-500': overdue }">
        <alo-icon icon="outline-clock" class="w-4 h-4" />
        <span class="leading-none">{{ cronômetro }}</span>
    </span>
</template>

<script>
import { utcParaLocal, formatarSegundosEmHHMMSS } from '@Shared/Date'

export default {
    props: ['relativo', 'warnOverdue', 'stopIf'],
    data() {
        let date = this.relativo ? utcParaLocal(this.relativo) : new Date()
        let segundos = (new Date().getTime() - date.getTime()) / 1000

        return {
            date,
            tempoEmSegundos: segundos,
            cronômetro: '00:00:00',
            overdueDate: this.warnOverdue ? utcParaLocal(this.warnOverdue) : null,
            overdue: false,
        }
    },
    watch: {
        relativo(val) {
            let date = utcParaLocal(val)
            let segundos = (new Date().getTime() - date.getTime()) / 1000

            this.date = date
            this.tempoEmSegundos = segundos
        },
        stopIf(val) {
            if (val) {
                clearInterval(this.interval)
            }
        },
    },
    mounted() {
        if (!this.stopIf) {
            this.onTick = this.tick.bind(this)
            this.interval = setInterval(this.onTick, 1000)

            this.onTick()
        }
    },
    destroyed() {
        clearInterval(this.interval)
    },
    methods: {
        tick() {
            if (!this.relativo) {
                this.cronômetro = '00:00:00'
                return
            }

            let currentTime = new Date().getTime()

            if (this.warnOverdue) {
                this.overdue = currentTime > this.overdueDate.getTime()
            }

            this.tempoEmSegundos = (currentTime - this.date.getTime()) / 1000
            this.cronômetro = formatarSegundosEmHHMMSS(this.tempoEmSegundos)
        },
    },
}
</script>